// extracted by mini-css-extract-plugin
export default {"container":"ContactList_container__CHSbd","head2":"ContactList_head2__MUkbk"};